import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectIdentificationService {

  private provider = new BehaviorSubject<{}>('');
 

  constructor() { }

  sendItem(providerInfo: string , serviceType: string, requestDate: string ){
    this.provider.next( {providerInfo, serviceType, requestDate} );
  }
  getItem(): Observable<{}>{
    return this.provider.asObservable();
  }

}
